import { render, staticRenderFns } from "./DisplayCouverturesOnShelf.vue?vue&type=template&id=76328840"
import script from "./DisplayCouverturesOnShelf.vue?vue&type=script&lang=js"
export * from "./DisplayCouverturesOnShelf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports